import Input from "./Input";
import Select from "./Select";

export default function UserForm({
  formData,
  onChange,
  isAdminForm = false,
  isNewUser = false,
  showVerifyCheckbox = false,
  isEditing = false,
  disabled = false,
  disableTutorSignup = false,
}) {
  const roleOptions = isAdminForm
    ? [
        { value: "student", label: "Student" },
        { value: "tutor", label: "Tutor" },
        { value: "admin", label: "Admin" },
      ]
    : [
        { value: "student", label: "Student" },
        ...(disableTutorSignup ? [] : [{ value: "tutor", label: "Tutor" }]),
      ];

  return (
    <div className="space-y-4">
      <Input
        label="First Name"
        type="text"
        name="firstName"
        required
        value={formData.firstName || ""}
        onChange={onChange}
        disabled={disabled}
      />
      <Input
        label="Last Name"
        type="text"
        name="lastName"
        required
        value={formData.lastName || ""}
        onChange={onChange}
        disabled={disabled}
      />
      <Input
        label="Email"
        type="email"
        name="email"
        required
        value={formData.email || ""}
        onChange={onChange}
        disabled={disabled || (!isAdminForm && !isNewUser)}
      />
      {isNewUser && (
        <Input
          label="Password (min 10 characters)"
          type="password"
          name="password"
          required
          value={formData.password || ""}
          onChange={onChange}
          autoComplete="new-password"
          disabled={disabled}
        />
      )}
      {(isAdminForm || isNewUser) && (
        <Select
          label={isAdminForm ? "Role" : "I am a"}
          name="role"
          value={formData.role || "student"}
          onChange={onChange}
          options={roleOptions}
          disabled={disabled}
        />
      )}

      {(isAdminForm || isNewUser) &&
        (formData.role === "student" || formData.role === "tutor") && (
          <Input
            label="College ID"
            type="text"
            name="cid"
            required
            value={formData.cid || ""}
            onChange={onChange}
            placeholder="e.g., STU2024001"
            disabled={disabled}
          />
        )}

      <Input
        label="Phone (optional)"
        type="tel"
        name="phone"
        value={formData.phone || ""}
        onChange={onChange}
        disabled={disabled}
      />

      {showVerifyCheckbox && (
        <label className="flex items-center">
          <input
            type="checkbox"
            name="isVerified"
            checked={formData.isVerified || false}
            onChange={(e) =>
              onChange({
                target: {
                  name: "isVerified",
                  value: e.target.checked,
                },
              })
            }
            className="w-4 h-4 rounded"
          />
          <span className="ml-2 text-sm text-text">Force Verify</span>
        </label>
      )}
    </div>
  );
}
